import module from 'app/module.js'
import './style.scss'

module.directive('appTableCell', () => {
  return {
    restrict: 'E',
  }
})



// WEBPACK FOOTER //
// ./src/app/components/table/cell/directive.js